import Config from "Config";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../component/AuthContext/AuthContext";
import { logout } from "../../redux/action";
import { getToken } from "../../redux/selector";
import { isNotEmpty } from "../../Utils";

// If user is inactive for 30mins, user will be considered as idle and being logged-out
export default function useTimeout() {
    const timeOutToken = useSelector(getToken());
    const dispatch = useDispatch();
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);
    const loggedIn = isNotEmpty(cookies?.token);
    const timeout = 60000 * 30; //30 mins
    const [isIdle, setIsIdle] = useState(false);
    const handleOnActive = () => setIsIdle(false);
    const handleOnIdle = () => {
        setIsIdle(true);
    };
    const { setIsChangingPassword } = useAuth();

    const { pause, start } = useIdleTimer({
        timeout,
        onActive: handleOnActive,
        onIdle: handleOnIdle,
    });
    const handleTimeout = () => {
        console.log("handleTimeout print log start");
        let printLogsParams = {
            logId: 20,
            msg: "print handleTimeout token:",
            params: "handleTimeout token =" + timeOutToken,
        };
        fetch(`${Config.CONTENT_PATH}/common/printLog`, {
            method: "POST", // 请求方法
            headers: {
                "Content-Type": "application/json", // 设置请求头
            },
            body: JSON.stringify(printLogsParams), // 请求体
        })
            .then((response) => {})
            .then((data) => {
                console.log("handleTimeout request successs:" + data);
            })
            .catch((error) => {
                console.error("handleTimeout request fail:" + error);
            });
        console.log("handleTimeout print log end");
        removeCookie("token", { path: `${Config.CONTENT_PATH}` });
        setIsChangingPassword(false);
        dispatch(logout());
    };
    useEffect(() => {
        if (loggedIn) {
            start();
        } else {
            pause();
        }
    }, [loggedIn]);
    if (isIdle) {
        handleTimeout();
        return true;
    }
    return false;
}
